import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconCasino: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.7 3h10.6c2.1 0 3.7 1.6 3.8 3.7v10.7c0 2.1-1.7 3.7-3.7 3.7H6.7c-2.1 0-3.7-1.7-3.7-3.7V6.7C3 4.6 4.6 3 6.7 3zm10.6 16c1 0 1.7-.8 1.7-1.7V6.7c0-1-.7-1.7-1.6-1.7H6.7C5.7 5 5 5.7 5 6.7v10.6c0 1 .7 1.7 1.7 1.7h10.6zm-3.8-7a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1.5-1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM10.5 15a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
